<template>
  <div id="floatingControlsDiv">
    <v-flex xs12>
      <div class="text-xs-center floating-controls-container">
        <div>
          <v-tooltip right>
            <v-btn
              id="increase-semantic-level-button"
              key="add"
              light
              small
              class="floating-controls-btn"
              @click="decreaseSemanticLevel"
              slot="activator"
            >
              <v-icon>expand_less</v-icon>
            </v-btn>
            <span>{{ $t('controls.canvas.contract') }}</span>
          </v-tooltip>
        </div>
        <div>
          <v-tooltip right>
            <v-btn
              id="decrease-semantic-level-button"
              key="subtract"
              light
              small
              class="floating-controls-btn"
              @click="increaseSemanticLevel"
              slot="activator"
            >
              <v-icon>expand_more</v-icon>
            </v-btn>
            <span>{{ $t('controls.canvas.expand') }}</span>
          </v-tooltip>
        </div>
        <div>
          <v-tooltip right>
            <v-btn
              id="fit-to-screen-button"
              key="my_location"
              light
              small
              class="floating-controls-btn"
              @click="handleCentreDiagram"
              slot="activator"
            >
              <v-icon>center_focus_weak</v-icon>
            </v-btn>
            <span>{{ $t('controls.canvas.fitToScreen') }}</span>
          </v-tooltip>
        </div>
<!--  @todo - SnapToGrid: will require Vuex to update options even when not logged in -->
<!--        <div>-->
<!--          <v-tooltip right>-->
<!--            <v-btn-->
<!--              id="fit-to-screen-button"-->
<!--              key="my_location"-->
<!--              light-->
<!--              small-->
<!--              class="floating-controls-btn"-->
<!--              @click="handleSnapToGrid"-->
<!--              slot="activator"-->
<!--            >-->
<!--              <img src="static/snapToGrid/noSnap.svg" />-->
<!--            </v-btn>-->
<!--            <span>{{ $t('controls.canvas.snapToGrid') }}</span>-->
<!--          </v-tooltip>-->
<!--        </div>-->
      </div>
    </v-flex>
    <span id="notch-bottom-left"></span>
  </div>
</template>

<script>

export default {
  name: 'FloatingControls',
  methods: {
    handleCentreDiagram () {
      this.$emit('centreDiagram')
    },
    increaseSemanticLevel () {
      this.$emit('increaseSemanticLevel')
    },
    decreaseSemanticLevel () {
      this.$emit('decreaseSemanticLevel')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#floatingControlsDiv {
  position: relative;
  bottom: 70px;
  left: 12px;
  z-index: 100;
}
.floating-controls {
  &-container {
    z-index: 2;
    position: relative;
    border: 1px solid $black-900;
    border-radius: 10px;
    padding: 5px 0;
    background-color: $bg-primary;
  }
  &-btn {
    min-width: 0;
    margin: 0;
    box-shadow: unset !important;
    background-color: $bg-primary !important;
  }
  &-icon {
    //background-color: $black-900;
  }
}
.tdsSquareButton.btn {
  min-width: 0;
  margin-top: 2px;
  margin-bottom: 0;
  padding: 0 2px 0 2px;
}
#notch-bottom-left {
  position: absolute;
  width: 40px;
  aspect-ratio: 1;
  background: $bg-primary;
  top: -16px;
  left: -12px;
  z-index: 1;
  --mask: radial-gradient(40px at 0 100%,#0000 98%,#000);
  -webkit-mask: var(--mask);
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  mask: var(--mask);
}
</style>



// WEBPACK FOOTER //
// src/components/parts/FloatingControls.vue